export default __webpack_public_path__ + "static/media/instagram-white.66f7d0e5.svg";